module.exports = __webpack_public_path__ + "img/close-menu.cba7d416.svg";